import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "value", "valueKey", "labelKey", "allowCreate", "returnValueKey", "onChange", "options"],
  _excluded2 = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from 'prop-types';
import React from 'react';
import Select from './select';
const SinglePicker = _ref => {
  let _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$valueKey = _ref.valueKey,
    valueKey = _ref$valueKey === void 0 ? 'id' : _ref$valueKey,
    _ref$labelKey = _ref.labelKey,
    labelKey = _ref$labelKey === void 0 ? 'name' : _ref$labelKey,
    _ref$allowCreate = _ref.allowCreate,
    allowCreate = _ref$allowCreate === void 0 ? false : _ref$allowCreate,
    _ref$returnValueKey = _ref.returnValueKey,
    returnValueKey = _ref$returnValueKey === void 0 ? null : _ref$returnValueKey,
    onChange = _ref.onChange,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? null : _ref$options,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const handleChange = incomingValue => {
    /* eslint-disable-next-line no-underscore-dangle */
    const isOtherValue = (incomingValue || {}).__isNew__;
    let val = null;
    const extractKey = allowCreate && returnValueKey && isOtherValue ? labelKey : returnValueKey;
    if (returnValueKey && incomingValue) {
      val = incomingValue[extractKey];
    } else if (incomingValue) {
      /**
       * Remove className but pass the rest back to onChange.  Some portions of
       * our application relies on more then just the data at labelKey and valueKey
       */
      const _JSON$parse = JSON.parse(JSON.stringify(incomingValue)),
        _ = _JSON$parse.className,
        rest = _objectWithoutProperties(_JSON$parse, _excluded2);
      val = rest;
    }
    onChange(val);
  };
  const prepareValue = () => {
    let result = value;
    if (value !== null && typeof result === 'object') {
      result = result[valueKey];
    }
    return result;
  };
  const selectProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    values: prepareValue(),
    multi: false,
    allowCreate,
    onChange: handleChange,
    className: "".concat(className, " t-sp"),
    value,
    valueKey,
    labelKey,
    returnValueKey,
    options
  });
  return /*#__PURE__*/React.createElement(Select, selectProps);
};
SinglePicker.propTypes = {
  className: PropTypes.string,
  labelKey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  valueKey: PropTypes.string,
  returnValueKey: PropTypes.string,
  allowCreate: PropTypes.bool,
  disabled: PropTypes.bool,
  verticalPadding: PropTypes.bool
};
export default SinglePicker;